import { useSession } from "@blitzjs/auth"

export function useAuth() {
  const session = useSession({ suspense: false })
  return {
    isAuthenticated: !!session.userId,
    userId: session.userId,
    role: session.role,
  }
}
